import { ucword } from "../lib/helper";
import React, { useEffect, useState, useMemo } from "react";
import ReactQuill from "react-quill";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import Spinner from "../components/Animations/Spinner";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "react-quill/dist/quill.snow.css";

const VideoDescription = ({
  church,
  currentUser,
  setFavoriteNote,
  onUpdateNote,
  editNote,
  setEditNote,
  currentVideoId,
  onAddNote,
}) => {
  const [bibleLoading, setBibleLoading] = useState(true);
  const navigate = useNavigate();
  const getCurrentNote = () => {
    if (!church || !church.notes) return [];

    return church.notes.filter(
      (note) => note.stream.videoId === currentVideoId
    );
  };

  const notesDefaultValue =
    getCurrentNote().length !== 0 ? getCurrentNote()[0].note : "";
  const [notesContent, setNotesContent] = useState(notesDefaultValue);

  const handleNoteChange = (value) => {
    setNotesContent(value);
    setFavoriteNote(value);
  };

  const onEditNoteClick = () => {
    redirectToLoginIfNotLoggedIn();

    setFavoriteNote(notesContent);
    setEditNote(true);
  };

  const onAddNoteClick = () => {
    redirectToLoginIfNotLoggedIn();

    onAddNote();
  };

  const onUpdateNoteClick = () => {
    redirectToLoginIfNotLoggedIn();

    onUpdateNote();
  };

  const redirectToLoginIfNotLoggedIn = () => {
    if (!currentUser) {
      navigate(`../../signin?redirect=${window.location.pathname}`);
    }
  };

  return (
    <div className="px-2 md:px-4 flex flex-row md:flex-col">
      <div className="md:grid grid grid-cols-1 md:grid-cols-1 space-y-2 w-full">
        <div className="church-detail-church-title">
          <h1 className="text-2xl font-semibold">{church.name}</h1>
          <div className="text-gray-500">
            <p className="font-semibold">
              City: {church?.city ? church?.city + "," : ""}{" "}
              {church.state && church.state.abbreviation}
            </p>

            {church?.seniorPastors?.length > 0 &&
            church.seniorPastors[0]?.name ? (
              <p className="font-semibold">
                Pastor: {ucword(church.seniorPastors[0]?.name)}
              </p>
            ) : (
              ""
            )}
          </div>
        </div>

        <Tabs>
          <TabList>
            <Tab onClick={() => setBibleLoading(true)}>Bible</Tab>
            <Tab>Notes</Tab>
          </TabList>
          <TabPanel>
            {bibleLoading && (
              <div className="p-20 text-center bible-loader">
                <Spinner size={10} />
              </div>
            )}
            <iframe
              id="myIframe"
              className="bible-container"
              src="https://www.bible.com/bible"
              onLoad={() => setBibleLoading(false)}
            />
          </TabPanel>
          <TabPanel>
            <div className="text-lg md:text-xl font-semibold">
              <ReactQuill
                theme="snow"
                value={notesContent}
                onChange={handleNoteChange}
                readOnly={getCurrentNote().length === 0 ? false : !editNote}
                placeholder="Notes..."
              />
              {getCurrentNote().length !== 0 ? (
                <div className="flex justify-end my-1">
                  {!editNote ? (
                    <button
                      type="button"
                      className="inline-block px-2 py-1 bg-transparent text-blue-500 font-medium text-xs leading-tight rounded hover:text-blue-600 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none focus:ring-0 active:bg-gray-200 transition duration-150 ease-in-out"
                      onClick={onEditNoteClick}
                    >
                      Edit Note
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="inline-block px-2 py-1 bg-transparent text-blue-500 font-medium text-xs leading-tight rounded hover:text-blue-600 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none focus:ring-0 active:bg-gray-200 transition duration-150 ease-in-out"
                      onClick={onUpdateNoteClick}
                    >
                      Submit
                    </button>
                  )}
                </div>
              ) : (
                <div className="flex justify-end my-1">
                  <button
                    type="button"
                    className="inline-block px-2 py-1 bg-transparent text-blue-500 font-medium text-xs leading-tight rounded hover:text-blue-600 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none focus:ring-0 active:bg-gray-200 transition duration-150 ease-in-out"
                    onClick={onAddNoteClick}
                  >
                    Add Note
                  </button>
                </div>
              )}
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
};

export default VideoDescription;
